import type { IssueSignals } from '@thom/folio-domain/core/ports/issues'
import { Collections } from '@thom/folio-ui/pocketbase-types'
import { filterFor } from '@thom/pb/filter-builder'
import { columns } from './issues-adapter'
import { NO_MATCH } from './project-clauses'
import type { Realtime } from './realtime'

type LinkColumns = {
	'domain.slug': string
	'domain.client.slug': string
}

const linkColumns = (project: string) => {
	const [client, domain] = project.split('/')

	return filterFor<LinkColumns>()([
		{ field: 'domain.slug', comparator: 'eq', value: domain || NO_MATCH },
		{ field: 'domain.client.slug', comparator: 'eq', value: client || NO_MATCH },
	])
}

const createIssueSignals = ({ client, connection }: Realtime): IssueSignals => ({
	issues: {
		source: { client, collection: Collections.JournIssues, map: record => record, connection },
		options: ({ project, filter }) => ({ filter: columns(project, { ...filter, roots: false, parentId: undefined }), sort: '-updated', perPage: 1 }),
	},
	links: {
		source: { client, collection: Collections.JournIssueLinks, map: record => record, connection },
		options: ({ project }) => ({ filter: linkColumns(project), sort: '-updated', perPage: 1 }),
	},
})

export { createIssueSignals }
